import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { userEnums } from '@vectronic/openApi-customer';
import { Item, ItemHelp } from '@vectronic/util';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-confirm-permission',
  templateUrl: './confirm-permission.component.html',
  styleUrls: ['./confirm-permission.component.scss'],
  imports: [CardComponent, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class ConfirmPermissionComponent implements OnInit {
  text: string;
  title: string;
  result: { confirm: boolean };
  dialogRef = inject(MatDialogRef<ConfirmPermissionComponent>);
  data: { type: Item; role?: userEnums.Role; multiple?: boolean } = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    let roleTag: string;
    if (this.data.role === 'DATA_MANAGER') {
      roleTag = 'Data Manager';
    } else if (this.data.role === 'DEVICE_MANAGER') {
      roleTag = 'Device Manager';
    } else {
      roleTag = 'Owner';
    }
    this.title = `${roleTag} Permission`;
    const itemText = `${ItemHelp.toDialogString(this.data.type)}${this.data.multiple ? 's.' : '.'}`;
    this.text = `By giving ${roleTag} permission the user can edit and share the ${itemText}`;
  }

  cancel() {
    this.dialogRef.close({ confirm: false } as typeof this.result);
  }

  confirm() {
    this.dialogRef.close({ confirm: true } as typeof this.result);
  }
}
